module.exports = __webpack_public_path__ + "media/images/captive_portal/Color-Four-78cbddec6acb204a7f4423898a373cc9.png";